"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The AtomLink model module.
 * @module model/AtomLink
 * @version 3.0
 */
var AtomLink = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>AtomLink</code>.
   * @alias module:model/AtomLink
   */
  function AtomLink() {
    _classCallCheck(this, AtomLink);
    AtomLink.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(AtomLink, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>AtomLink</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AtomLink} obj Optional instance to populate.
     * @return {module:model/AtomLink} The populated <code>AtomLink</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new AtomLink();
        if (data.hasOwnProperty('rel')) {
          obj['rel'] = _ApiClient["default"].convertToType(data['rel'], 'String');
        }
        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], ['String']);
        }
        if (data.hasOwnProperty('method')) {
          obj['method'] = _ApiClient["default"].convertToType(data['method'], 'String');
        }
        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }
        if (data.hasOwnProperty('href')) {
          obj['href'] = _ApiClient["default"].convertToType(data['href'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AtomLink</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AtomLink</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['rel'] && !(typeof data['rel'] === 'string' || data['rel'] instanceof String)) {
        throw new Error("Expected the field `rel` to be a primitive type in the JSON string but got " + data['rel']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['type'])) {
        throw new Error("Expected the field `type` to be an array in the JSON data but got " + data['type']);
      }
      // ensure the json data is a string
      if (data['method'] && !(typeof data['method'] === 'string' || data['method'] instanceof String)) {
        throw new Error("Expected the field `method` to be a primitive type in the JSON string but got " + data['method']);
      }
      // ensure the json data is a string
      if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
        throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
      }
      // ensure the json data is a string
      if (data['href'] && !(typeof data['href'] === 'string' || data['href'] instanceof String)) {
        throw new Error("Expected the field `href` to be a primitive type in the JSON string but got " + data['href']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} rel
 */
AtomLink.prototype['rel'] = undefined;

/**
 * @member {Array.<String>} type
 */
AtomLink.prototype['type'] = undefined;

/**
 * @member {String} method
 */
AtomLink.prototype['method'] = undefined;

/**
 * @member {String} name
 */
AtomLink.prototype['name'] = undefined;

/**
 * @member {String} href
 */
AtomLink.prototype['href'] = undefined;
var _default = exports["default"] = AtomLink;